import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useKeydownHandler from './useKeydownHandler';

import {
  ButtonStyledDismiss,
  SpanStyled,
} from './styles';

export const DismissComponent = ({
  ariaLabel = 'dismiss',
  className,
  id,
  onClick,
  themeType = 'lightTheme',
}) => {
  // refs
  const modalCloseEl = useRef();

  useKeydownHandler(modalCloseEl, onClick);

  return (
    <ButtonStyledDismiss
      {...ariaLabel && { 'aria-label': ariaLabel }} // NOTE: React implements exceptions to JSX, "aria-*" is one of them: https://reactjs.org/docs/accessibility.html
      {...id && { id }}
      className={classNames(className, 'nmx-button-dismiss')}
      onClick={onClick}
      ref={modalCloseEl}
      themeType={themeType}
    >
      <SpanStyled
        className='nmx-icon'
        themeType={themeType}
      />
    </ButtonStyledDismiss>
  );
};

DismissComponent.propTypes = {
  /** Optional ariaLabel attribute, used for ADA to add more description to the Button (what will happen when clicked) */
  ariaLabel: PropTypes.string,
  /** Optional custom class name */
  className: PropTypes.string,
  /** optional id for the Dismiss button */
  id: PropTypes.string,
  /** Optional onClick function */
  onClick: PropTypes.func,
  // TODO: add in darkTheme styles
  /** Optional themeType */
  themeType: PropTypes.oneOf(['lightTheme', 'darkTheme']),
};

export default DismissComponent;
